import {
  shipperVendorConfigPropertySelector,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {FEDEX} from '../../../common/constants/ShipperNames.js'
import {useSelector} from '../../../store.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [FEDEX]

function labelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__priority_alert`]
    : []
}

export default function PriorityAlert() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = PriorityAlert.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  let [has_priority_alert] = useSelector((state) =>
    shipperVendorConfigPropertySelector(state, {
      labelInfoID,
      shipperType,
      property: 'has_priority_alert',
    }),
  )

  return (
    <ConfigSelect
      label="Priority Alert"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="priority_alert"
      hide={!has_priority_alert}
    />
  )
}

PriorityAlert.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
